import gql from 'graphql-tag';

import { SESSION_USER_FIELDS } from 'app/shared/graphql/sessions/queries';

// Used on the checkout page's 'Order Complete' stage
export const GET_EVENT_ATTENDEE_FOR_EXPRESS_GUEST_CHECKOUT = gql`
  query GetEventAttendee($id: Int) {
    eventAttendee(id: $id) {
      id
      user {
        ...SessionUserFields
        lastAuthMethod
        resetPasswordToken
      }
    }
  }
  ${SESSION_USER_FIELDS}
`;
